import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from '@nuxtjs/composition-api';

interface Props {
    tag?: string;
    reverse?: boolean;
}

type PointerCoords = { x: number, y: number };


export default /*#__PURE__*/_defineComponent({
  __name: 'PointerScrollable',
  props: {
    tag: { default: 'div' },
    reverse: { type: Boolean, default: true }
  },
  emits: ['scroll', 'scrollstart', 'scrollend'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { tag: string, reverse: boolean };



const {
    reverse,
} = toRefs(props);



const mouseDown = ref<PointerEvent['pointerId'] | null>(null);
const container = ref<HTMLElement | null>(null);

const isHoveredNodeSelectable = (node: Element) => {
    return window.getComputedStyle(node).getPropertyValue('user-select') !== 'none';
};

const willNodeBeSelectedOnDrag = (node: Element, { x: pointerX, y: pointerY }: PointerCoords) => {
    const range = document.createRange();
    range.selectNodeContents(node);
    const clientRects = range.getClientRects();
    for (let i = 0; i < clientRects.length; i++) {
        if (clientRects[i].left <= pointerX && pointerX <= clientRects[i].right &&
            clientRects[i].top <= pointerY && pointerY <= clientRects[i].bottom) {
            return true;
        }
    }
    return false;
};

const checkSelectableTextUnderPointer = (coords: PointerCoords) => {
    const elementUnderMouse = document.elementFromPoint(coords.x, coords.y);
    if (isHoveredNodeSelectable(elementUnderMouse)) {
        return willNodeBeSelectedOnDrag(elementUnderMouse, coords);
    }
    return false;
};

const getBoundedScroll = (scrollTo: number, maxScroll: number) => {
    return Math.min(
        Math.max(
            scrollTo,
            0,
        ),
        maxScroll,
    );
};

const handlePointerDown = (e: PointerEvent) => {
    if (!container.value) return;
    const isOnSelectableText = checkSelectableTextUnderPointer({ x: e.clientX, y: e.clientY });
    if (isOnSelectableText) return;
    mouseDown.value = e.pointerId;
    container?.value?.setPointerCapture(mouseDown.value);
    $emit('scrollstart', e);
};

const handlePointerMove = (e: PointerEvent) => {
    if (mouseDown.value !== e.pointerId) return;
    const element = container.value;
    if (!element) return;
    document.getSelection()?.removeAllRanges();
    element.classList.add('user-select-none');
    const coef = reverse.value ? -1 : 1;
    element.scrollTop = getBoundedScroll(
        element.scrollTop + e.movementY * coef,
        element.scrollHeight - element.clientHeight,
    );
    element.scrollLeft = getBoundedScroll(
        element.scrollLeft + e.movementX * coef,
        element.scrollWidth - element.clientWidth,
    );
    $emit('scroll', e);
};

const handlePointerCancel = (e: PointerEvent) => {
    const element = container.value;
    if (!element) return;
    if (typeof mouseDown.value !== 'number' || mouseDown.value === null) return;
    element.releasePointerCapture(mouseDown.value);
    element.classList.remove('user-select-none');
    mouseDown.value = null;
    $emit('scrollend', e);
};


return { __sfc: true,props, reverse, $emit, mouseDown, container, isHoveredNodeSelectable, willNodeBeSelectedOnDrag, checkSelectableTextUnderPointer, getBoundedScroll, handlePointerDown, handlePointerMove, handlePointerCancel }
}

})